//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "pagination",
    props: {
        totalNum:{ //总页数
          type: Number,
          default: 1,
        },
    },
    data(){
        return {
            currPage: 1,//当前页
            page: {
                page_index: 1,
                page_limit: 15
            }
        }
    },
    methods:{
        lastPage(){
            if(this.page.page_index > 1){
             this.page.page_index -= 1;
             this.$emit('pageChange', this.page);
            }else{
              //alert("已经是第一页")
            }
        },
        nextPage(){
            if(this.page.page_index < this.totalNum){
               this.page.page_index += 1;
               this.$emit('pageChange', this.page);
            }else{
              //alert("已经是最后一页")
            }
        },
        changPage(e){
            this.page.page_index = e;
            this.$emit('pageChange', this.page);
        }
    }
}



// WEBPACK FOOTER //
// ./src/pcpage/hr/recruitment/portal/component/pagination.vue